(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('[data-collection-hero]');

    heroes.forEach((hero) => {
      const scrollBtn = hero.querySelector('[data-hero-scroll]');
      if (scrollBtn) {
        scrollBtn.addEventListener('click', () => {
          const next = hero.nextElementSibling;
          const top = next
            ? next.getBoundingClientRect().top + window.scrollY
            : hero.offsetHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      }

      const isOverlay = hero.classList.contains('collection-hero--layout-overlay');
      if (!isOverlay) return;

      const media = hero.querySelector('[data-hero-media]');
      if (!media) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let ticking = false;
      const update = () => {
        const rect = hero.getBoundingClientRect();
        const viewH = window.innerHeight;
        if (rect.bottom < 0 || rect.top > viewH) { ticking = false; return; }
        const progress = Math.max(Math.min(-rect.top / hero.offsetHeight, 1), 0);
        media.style.transform = `translate3d(0, ${progress * 60}px, 0)`;
        ticking = false;
      };
      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
